export enum whatsappText {
  NEW_CAR = 'Hai, Saya berminat untuk membeli mobil',
  USED_CAR = 'Hai, Saya berminat untuk membeli mobil bekas',
}

export enum sourceCodeWhatsapp {
  SALESMAN = 'ChatDigiroomSalesman',
  NEW_CAR_PLP = 'ChatDigiroomPLP',
  NEW_CAR_PDP = 'ChatDigiroomPDP',
  BRANCH_LISTING = 'ChatDigiroomCabang',
  SIMULATION_CREDIT = 'ChatDigiroomSimulasiKredit',
  HOMEPAGE = 'ChatDigiroomHome',
}
